import {
  AtsJobApplicationHeaderDocument,
  AtsJobApplicationReviewerHeaderDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { JobApplicationHeader } from './'
import { JobApplicationReviewHeader } from './ReviewerHeader'

interface Props {
  isReviewerRole: boolean // TODO: change to enum from GraphQl (?)
  applicationId: number
}

export const JobApplicationComponentHeader: React.FC<Props> = ({
  isReviewerRole,
  applicationId,
}) => {
  const { company } = useCurrentSession()
  const { data: recruiterData } = useQuery(AtsJobApplicationHeaderDocument, {
    variables: {
      id: applicationId,
      companyId: company.id,
    },
    skip: isReviewerRole,
  })

  const { data: reviewerData } = useQuery(AtsJobApplicationReviewerHeaderDocument, {
    variables: {
      id: applicationId,
      companyId: company.id,
    },
    skip: !isReviewerRole,
  })

  const reviewerApplication = reviewerData?.ats.applicationsConnection.nodes[0]
  const recruiterApplication = recruiterData?.ats.applicationsConnection.nodes[0]

  if (reviewerData && reviewerApplication) {
    return (
      <JobApplicationReviewHeader
        applicationData={reviewerApplication}
        features={reviewerData.features}
      />
    )
  }

  if (recruiterData && recruiterApplication) {
    return (
      <JobApplicationHeader
        applicationData={recruiterApplication}
        features={recruiterData.features}
        featureAvailabilities={recruiterData.companies}
        talentPoolByDefault={
          recruiterData.ats.companiesConnection.nodes[0]?.talentPoolByDefault ?? false
        }
        participants={recruiterData.ats.applicationParticipantsConnection.nodes}
        hasOfferLetter={!!recruiterData.ats.offerLetters[0]?.status}
        canCallCandidatePolicy={recruiterData?.ats._policies.callCandidate.can}
      />
    )
  }

  return null
}
